'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { usageTrackerActions } from 'usage-tracker-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import Small from 'UIComponents/elements/Small';
import { getExtraJsonForAction } from 'DesignComponents/utils/usageTracker/eventUtils';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
const {
  track
} = usageTrackerActions;

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.copyFieldsJsonButton.${key}`;

const CopyFieldsJsonButton = ({
  fields = []
}) => {
  const dispatch = useDispatch();
  const copyValue = JSON.stringify(fields, null, ' ');

  const trackCopy = () => {
    dispatch(track('customWidgetInteraction', getExtraJsonForAction('field-json-copied')));
  };

  return /*#__PURE__*/_jsx(UICopyButton, {
    disabled: fields.length === 0,
    use: "link",
    value: copyValue,
    onClick: trackCopy,
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('label')
      })
    })
  });
};

CopyFieldsJsonButton.propTypes = {
  fields: PropTypes.oneOfType([PropTypes.instanceOf(CustomWidgetField), PropTypes.arrayOf(PropTypes.instanceOf(CustomWidgetField))])
};
export default CopyFieldsJsonButton;